import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export function VerifyPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [isVerifying, setIsVerifying] = useState(true);
  const { verifyMagicLink } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setError('Invalid or missing verification token');
      setIsVerifying(false);
      return;
    }

    const verify = async () => {
      try {
        await verifyMagicLink(token);
        // Redirect to dashboard on success
        navigate('/', { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Verification failed');
        setIsVerifying(false);
      }
    };

    verify();
  }, [searchParams, verifyMagicLink, navigate]);

  if (isVerifying) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-gray-600">Verifying your login...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <div className="mx-auto h-16 w-16 bg-red-100 rounded-full flex items-center justify-center">
              <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
              Verification failed
            </h2>
            <p className="mt-4 text-gray-600">{error}</p>
            <p className="mt-2 text-sm text-gray-500">
              The magic link may have expired or already been used.
            </p>
          </div>

          <div className="mt-8">
            <button
              onClick={() => navigate('/login')}
              className="btn-primary w-full"
            >
              Back to login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
